import { CAPABILITY } from "./permissions";

/**
 * Administration section registry.
 * Capability keys use compatibility aliases defined in permissions.js.
 */
export const ADMIN_SECTIONS = Object.freeze([
  {
    id: "overview",
    label: "Overview",
    group: null,
    capability: CAPABILITY.ADMIN_SETTINGS_VIEW,
    icon: "📋",
  },
  {
    id: "organization",
    label: "Organization",
    group: "Company",
    capability: CAPABILITY.ADMIN_ORGANIZATION_MANAGE,
    icon: "🏢",
  },
  {
    id: "work_schedule",
    label: "Work Schedule",
    group: "Company",
    capability: CAPABILITY.ADMIN_ORGANIZATION_MANAGE,
    icon: "🗓️",
  },
  {
    id: "branding",
    label: "Branding",
    group: "Company",
    capability: CAPABILITY.ADMIN_BRANDING_MANAGE,
    icon: "🎨",
  },
  {
    id: "feature_flags",
    label: "Feature Flags",
    group: "Company",
    capability: CAPABILITY.ADMIN_FEATURES_MANAGE,
    icon: "🚩",
  },
  {
    id: "subscription",
    label: "Subscription",
    group: "Company",
    capability: CAPABILITY.ADMIN_BILLING_VIEW,
    icon: "💳",
  },
  {
    id: "users",
    label: "Users",
    group: "People",
    capability: CAPABILITY.SCREEN_USER_MANAGEMENT,
    icon: "👥",
  },
  {
    id: "invitations",
    label: "Organization Invitations",
    group: "People",
    capability: CAPABILITY.ADMIN_ORGANIZATION_MANAGE,
    icon: "✉️",
  },
  {
    id: "roles",
    label: "Roles & Permissions",
    group: "People",
    capability: CAPABILITY.ADMIN_ROLES_MANAGE,
    icon: "🔐",
  },
  {
    id: "trades",
    label: "Trades",
    group: "Payroll",
    capability: CAPABILITY.ADMIN_TRADES_MANAGE,
    icon: "🔧",
  },
  {
    id: "classifications",
    label: "Classifications",
    group: "Payroll",
    capability: CAPABILITY.ADMIN_CLASSIFICATIONS_MANAGE,
    icon: "📊",
  },
  {
    id: "payroll_types",
    label: "Payroll Types",
    group: "Payroll",
    capability: CAPABILITY.ADMIN_PAYROLL_TYPES_MANAGE,
    icon: "🏷️",
  },
  {
    id: "payroll_settings",
    label: "Payroll Settings",
    group: "Payroll",
    capability: CAPABILITY.ADMIN_PAYROLL_SETTINGS,
    icon: "⚙️",
  },
  {
    id: "payroll",
    label: "Payroll Rates",
    group: "Payroll",
    capability: CAPABILITY.ADMIN_PAYROLL_SETTINGS,
    icon: "💰",
  },
  {
    id: "work_types",
    label: "Work Types",
    group: "Time Tracking",
    capability: CAPABILITY.ADMIN_WORK_TYPES_MANAGE,
    icon: "⏱️",
  },
  {
    id: "projects",
    label: "Projects",
    group: "Operations",
    capability: CAPABILITY.ADMIN_PROJECTS_SETTINGS,
    icon: "📁",
  },
  {
    id: "materials",
    label: "Materials",
    group: "Operations",
    capability: CAPABILITY.ADMIN_MATERIALS_SETTINGS,
    icon: "📦",
  },
  {
    id: "estimates",
    label: "Estimates",
    group: "Commercial",
    capability: CAPABILITY.ADMIN_ESTIMATES_SETTINGS,
    icon: "📝",
  },
  {
    id: "invoices",
    label: "Invoice Settings",
    group: "Commercial",
    capability: CAPABILITY.ADMIN_INVOICES_SETTINGS,
    icon: "🧾",
  },
  {
    id: "reports",
    label: "Reports",
    group: "Commercial",
    capability: CAPABILITY.ADMIN_REPORTS_SETTINGS,
    icon: "📄",
  },
  {
    id: "notifications",
    label: "Notifications",
    group: "System",
    capability: CAPABILITY.ADMIN_NOTIFICATIONS_SETTINGS,
    icon: "🔔",
  },
  {
    id: "offline",
    label: "Offline",
    group: "System",
    capability: CAPABILITY.ADMIN_OFFLINE_SETTINGS,
    icon: "📡",
  },
  {
    id: "help_learning",
    label: "Help & Learning",
    group: "System",
    capability: CAPABILITY.ADMIN_HELP_LEARNING_SETTINGS,
    icon: "🎓",
  },
  {
    id: "integrations",
    label: "Integrations",
    group: "System",
    capability: CAPABILITY.ADMIN_INTEGRATIONS_MANAGE,
    icon: "🔗",
  },
  {
    id: "advanced",
    label: "Advanced",
    group: "System",
    capability: CAPABILITY.ADMIN_ADVANCED_MANAGE,
    icon: "⚙️",
  },
]);

export function getAdminSection(sectionId) {
  return ADMIN_SECTIONS.find((section) => section.id === sectionId) || null;
}

export function getVisibleAdminSections(can) {
  return ADMIN_SECTIONS.filter((section) => can(section.capability));
}

export function canAccessAdminSection(can, sectionId) {
  const section = getAdminSection(sectionId);
  if (!section) {
    return false;
  }
  return can(section.capability);
}

export function groupAdminSections(sections) {
  const groups = new Map();
  groups.set("", []);

  for (const section of sections) {
    if (!section.group) {
      groups.get("").push(section);
      continue;
    }
    if (!groups.has(section.group)) {
      groups.set(section.group, []);
    }
    groups.get(section.group).push(section);
  }

  return groups;
}
